module.exports = __webpack_public_path__ + "static/media/matrix_ms.3c9f3c62.png";